<template>
  <section
    class="section section-lg section-shaped overflow-hidden my-0"
    id="activites"
  >
    <div class="container py-0 pb-lg">
      <div class="justify-content-between align-items-center">
        <div class="col-lg-100 mb-5 mb-lg-0 text-center">
          <h1 class=" font-weight-light">
            Découvrez nos activités
          </h1>
        </div>
        <carousel
          :per-page="1"
          :loop="true"
          :autoplay="true"
          :autoplay-timeout="3000"
          :navigation-enabled="false"
          :pagination-enabled="true"
        >
          <slide v-for="(item, i) in tabl" :key="i" class="slide">
            <img
              @click="handleSlideClick(item)"
              :src="item.image"
              class="img-carous img"
            />
          </slide>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import titreTemplate from "@/views/myComponent/titreTemplate";
import { Carousel, Slide } from "vue-carousel";
import Image1 from "@/../public/img/theme/1.png";
import Image2 from "@/../public/img/theme/2.png";
import Image3 from "@/../public/img/theme/3.png";
import Image4 from "@/../public/img/theme/4.png";
import Image5 from "@/../public/img/theme/5.png";

export default {
  components: {
    titreTemplate,
    Carousel,
    Slide,
  },
  data() {
    return {
      tabl: [
        {
          title: "Le vélo publicitaire",
          image: Image1,
          slug: "moving board",
          description:
            "À l'ère de la saturation numérique, il est crucial de se démarquer avec des solutions innovantes et écologiques. Le vélo publicitaire offre une plateforme unique pour promouvoir votre marque de manière dynamique et durable. Equipé d'un panneau publicitaire personnalisé, il devient un ambassadeur mobile de votre message, captant l'attention dans les zones urbaines animées, sur les promenades côtières, lors des événements sportifs ou culturels.",
          imageSrc: "velo",
        },
        {
          title: "Le Moving Board",
          image: Image3,
          slug: "moving board",
          description:
            "Communément appelé  \"hommes sandwiches\", les moving boards attirent l'attention en présentant le message publicitaire de manière directe et souvent originale. Ils peuvent se déplacer dans des zones très fréquentées où d'autres formes de publicité ne sont pas possibles comme les panneaux publicitaires statiques.<br /><br />En étant mobiles et en interagissant directement avec les passants, les \"hommes sandwiches\" peuvent susciter une réponse immédiate du public. Cela peut inclure des questions sur le produit ou service promu, des demandes d'informations supplémentaires, ou même des photos partagées sur les réseaux sociaux, augmentant ainsi l'engagement. <br /><br />Ils peuvent être facilement déployées et adaptées à différents lieux et événements. Cela permet de cibler spécifiquement les zones où se trouve le public cible et où une visibilité maximale est souhaitée.",
          imageSrc: "mooving",
        },
        {
          title: "Tricycle Pub",
          image: Image2,
          slug: "moving board",
          description:
            "Le téléphone géant est une forme de publicité mobile qui utilise un tricycle spécialement équipé pour afficher des messages publicitaires.<br /><br />Ces tricycles se déplacent directement parmi les piétons et les véhicules, attirant ainsi une attention significative et offrant une meilleure exposition que les panneaux publicitaires. Les tricycles peuvent être dirigés vers des zones spécifiques où se trouve le public cible, comme les centres-villes,  les festivals, les événements sportifs, ou les lieux de rassemblement ; ils peuvent être facilement adaptées pour refléter les thèmes saisonniers, les tendances locales, ou les promotions spéciales, offrant ainsi une grande flexibilité créative.",
          imageSrc: "telephone",
        },
        {
          title: "Le Journal Géant",
          image: Image4,
          slug: "journal pub",
          description:
            "La lecture est faite pour être partagée. C’est en tout cas le message que semble afficher le journal de 1,40 m de large que nous faisons imprimer avec vos messages. Il ressemble à une véritable « une », tout droit sortie de la presse quotidienne. Mais c’est surtout de vous qu’elle parle ! <br /><br />Sa double page suffit pour attirer toute l’attention dont vous avez besoin : grâce à sa taille impressionnante, elle se repère de loin. En apercevant ces articles de presse surdimensionnés, chacun a envie de lire par-dessus l’épaule de celui qui les tient. Nous avons souvent vu des personnes se rapprocher subrepticement pour comprendre ce qu’il se passait autour de ces quotidiens géants.<br /><br />Et nous faisons tout pour les mettre en valeur : nos hôtesses s’installent confortablement mais, surtout, bien en vue. Les lieux stratégiques de la ville ne manquent pas pour faire une bonne impression et nous les connaissons tous.",
          imageSrc: "journal",
        },
        {
          title: "Prospection commerciale",
          image: Image5,
          slug: "vente commerciale",
          description:
            "La distribution de flyers est une stratégie de marketing direct où des flyers (ou dépliants publicitaires) sont distribués manuellement à des personnes dans des lieux publics ou ciblés. Utilisés pour promouvoir des produits, services, événements ou promotions spécifiques, l'objectif ici  est d'atteindre directement le public cible dans des lieux stratégiques comme les centres commerciaux, les rues commerçantes, les événements sportifs ou culturels, les stations. Ils sont conçus pour être visuellement attrayants et informatifs.<br /><br />Nos équipes sont déployées sur le terrain pour distribuer les flyers à des passants ou des consommateurs potentiels.Ils permettent une large portée, d'atteindre un grand nombre de personnes dans des zones fréquentées et sont relativement peu coûteuses. Nous mesurons l'efficacité de nos campagne en suivant le taux de conversion des offres spéciales ou en demandant aux clients comment ils ont découvert l'entreprise.",
          imageSrc: "vente",
        },
      ],
    };
  },
  methods: {
    galerie() {
      this.$router.push("/galerie");
    },
    handleSlideClick(item) {
      localStorage.setItem("service", JSON.stringify(item));
      this.$router.push("/service");
    },
  },
};
</script>

<style>
.porteur {
  padding: 15px;
  width: 100%;
  background: #166276eb;
  border-radius: 5px;
  border: 2px solid white;
}

.description {
  font-weight: 400;
}
.hopper {
  height: auto;
  color: black;
}
.titre-carous {
  font-size: 16px;
  font-weight: 500;
}
.slide {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.det-ses {
  background-color: #3cb59e;
  padding: 5px 20px 20px 20px;
  margin-top: 0px;
  border-radius: 0px 0px 20px 20px;
}

.slide:hover {
  .det-ses {
    background-color: #ffce00;
  }
  .titre-carous {
    color: black !important;
  }
}

.img-carous {
  height: auto;
  width: 100%;
  object-fit: cover;
  background: linear-gradient(
    0deg,
    rgba(231, 233, 234, 1) 0%,
    rgba(75, 117, 171, 1) 100%
  );
}

@media screen and (min-width: 1536px) {
  #contentimg {
    width: 250px;
  }
}
</style>
